"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payoutFeeFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.payoutFeeFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    collect_payout_id: Factory.each(i => i + 1),
    currency_type: 'USD',
    deduct_payout_id: Factory.each(i => i + 1),
    due_date: mocks_1.dates.date2100,
    fee_cents: 100,
    fee_id: Factory.each(i => i + 1),
    source_system: 'system',
    source_system_id: 1,
    tenant_due_date: mocks_1.dates.date2100,
    tenant_id: 1,
    tenant_name: 'tenant_name',
    tenant_name_suffix: 'suffix',
    tenant_type: 'tenant_type',
    transaction_date: mocks_1.dates.date2000,
});
